import React, { useContext } from 'react'
import { Card } from 'antd'
import { OrderFormContext } from '../../contexts'
import useFormatMoney from '../../hooks/useFormatMoney'

const CartSummarize = () => {
  const formatMoney = useFormatMoney()

  const {
    totalPrice,
    formTitle,
    box
  } = useContext(OrderFormContext)

  let finalPrice = totalPrice

  if (box) {
    finalPrice += box.quantity * box.price
  }

  return (
    <Card className="ShoppingCart" bordered={false}>
      <div className="ShoppingCart__Container">
        <span className="ShoppingCart__Title">{formTitle}</span>
        <span className="ShoppingCart__Price">
          {`$${formatMoney(finalPrice)}`}
        </span>
      </div>
    </Card>
  )
}

export default CartSummarize
